import React from "react";
import "../../Dashboard/ShoppingCart/Checkout/checkout.scss";

const Welcomesmiklearn = () => {
  return (
    <>
      <div className="checkout-container">
        <div className="welcomeNewUser">
          <div className="checkout-content">Welcome! To yslearn</div>
          <div className="success-icon"></div>
          <div className="checkout-content">
            <p>You have successfully activated your account!</p>
            <p>
              You can now login to your account using the userName and password
              you saved during registration.
            </p>
            <p>
             If you forgot your username or password,click here to reset.
            </p>
          </div>
          <div className="checkout-content">
            <p>Happy Learning!!!</p>
            <p>Team yslearn</p>
          </div>
        </div>
      </div>
    </>
  );
};
export default Welcomesmiklearn;
